// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"pageContainer--F3whUMXn0XiuS0fwc4Mt"};